<template>
  <div class="merchant-management">
    <div class="right" v-loading="loading">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <el-input
              
              v-model="search.merchantName"
              placeholder="请输入商家名称"
            ></el-input>
          </div>
          <div class="form-group">
            <el-select
              v-model="search.categoryId"
              placeholder="请选择商户分类"
            >
              <el-option
                v-for="item in merchantCategories"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <!-- <div class="form-group">
            <label>联系电话:</label>
            <el-input
              v-model="search.phone"
              placeholder="请输入联系电话"
            ></el-input>
          </div> -->
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
               :disabled="loading">
              <i v-if="loading" class="el-icon-loading"></i>
              {{ loading ? "查询中..." : "查询" }}
            </button>
            </span>
          </div>
        </form>
      </div>

      <!-- 状态筛选标签页 -->
      <el-tabs
        v-model="activeTab"
        @tab-click="handleTabClick"
        class="status-tabs"
      >
        <el-tab-pane label="全部" name="all">
          <template slot="label">
            <span>全部</span>
            <el-badge :value="statistics.total" class="tab-badge" />
          </template>
        </el-tab-pane>
        <el-tab-pane label="待完善" name="toBeComplete">
          <template slot="label">
            <span>待完善</span>
            <el-badge :value="statistics.toBeComplete" class="tab-badge" />
          </template>
        </el-tab-pane>
        <el-tab-pane label="待认证" name="pending">
          <template slot="label">
            <span>待认证</span>
            <el-badge :value="statistics.pending" class="tab-badge" />
          </template>
        </el-tab-pane>
        <el-tab-pane label="认证不通过" name="rejected">
          <template slot="label">
            <span>认证不通过</span>
            <el-badge :value="statistics.rejected" class="tab-badge" />
          </template>
        </el-tab-pane>
        <el-tab-pane label="已认证" name="approved">
          <template slot="label">
            <span>已认证</span>
            <el-badge :value="statistics.approved" class="tab-badge" />
          </template>
        </el-tab-pane>
      </el-tabs>

      <template>
        <div v-show="showList" class="list-right table">
          <el-table
            ref="table"
            border
            :data="tableListData"
            height="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
          >
            <el-table-column
              show-overflow-tooltip
              label="商家分类"
              prop="categoryName"
              width="120"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="状态"
              prop="auditStatus"
              width="100"
            >
              <template slot-scope="scope">
                <el-tag
                  :type="getStatusType(scope.row.auditStatus)"
                  size="small"
                >
                  {{ getStatusText(scope.row.auditStatus) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="商家名称"
              prop="merchantName"
              width="150"
            ></el-table-column>

            <el-table-column
              show-overflow-tooltip
              label="地址"
              prop="address"
              width="200"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="联系人"
              prop="userName"
              width="120"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="电话"
              prop="phone"
              width="120"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="营业时间"
              prop="businessHours"
              width="150"
            ></el-table-column>
            <el-table-column show-overflow-tooltip label="经纬度" width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.pointLat && scope.row.pointLng"
                  >{{ scope.row.pointLat }}, {{ scope.row.pointLng }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="商家图片"
              prop="imageUrl"
              width="120"
            >
              <template slot-scope="scope">
                <button
                  :style="{
                    margin: '5px',
                    padding: '0 10px',
                    'box-sizing': 'border-box',
                    cursor: !scope.row.imageUrl ? 'not-allowed' : 'pointer',
                  }"
                  type="primary"
                  @click="onImgPreviewClick(scope.row)"
                  :disabled="!scope.row.imageUrl"
                >
                  预览图片
                </button>
              </template>
            </el-table-column>

            <el-table-column
              show-overflow-tooltip
              label="创建时间"
              prop="crtTime"
              width="150"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="更新时间"
              prop="updTime"
              width="150"
            ></el-table-column>
            <el-table-column
              v-if="activeTab === 'approved'"
              show-overflow-tooltip
              label="上下架"
              width="100"
            >
              <template slot-scope="scope">
                <div>
                  <!-- 调试信息 -->
                  <!-- <small style="color: #999; font-size: 10px; display: block;">
                    published: {{ scope.row.published }} ({{ typeof scope.row.published }})
                  </small> -->
                  <el-switch
                    v-model="scope.row.published"
                    :disabled="scope.row.auditStatus !== 0"
                    @change="handleShelfChange(scope.row)"
                    :active-value="1"
                    :inactive-value="2"
                    active-color="#13ce66"
                    inactive-color="#999999"
                  >
                  </el-switch>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="activeTab === 'approved'"
              show-overflow-tooltip
              label="排序"
              width="120"
            >
              <template slot-scope="scope">
                <div class="sort-edit-container">
                  <span v-if="!scope.row.editingSort" class="sort-display">
                    {{ scope.row.sort }}
                    <!-- 调试信息 -->
                    <!-- <small style="color: #999; font-size: 10px;">
                      (编辑: {{ scope.row.editingSort }}, 认证: {{ scope.row.auditStatus }})
                    </small> -->
                    <i 
                      class="el-icon-edit sort-edit-icon" 
                      @click="startSortEdit(scope.row)"
                      v-if="scope.row.auditStatus === 0"
                      title="点击编辑排序"
                    ></i>
                  </span>
                  <div v-else class="sort-edit-input">
                    <el-input-number
                      v-model="scope.row.tempSort"
                      :min="0"
                      :max="9999"
                      size="mini"
                      style="width: 80px;"
                    ></el-input-number>
                    <i 
                      class="el-icon-check sort-confirm-icon" 
                      @click="confirmSortEdit(scope.row)"
                    ></i>
                    <i 
                      class="el-icon-close sort-cancel-icon" 
                      @click="cancelSortEdit(scope.row)"
                    ></i>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="350px">
              <template slot-scope="scope">
                <div style="display: flex; gap: 5px; flex-wrap: wrap">
                  <el-button
                    size="mini"
                    type="info"
                    @click="viewDetail(scope.row)"
                  >
                    查看详情
                  </el-button>
                  <el-button
                    size="mini"
                    type="success"
                    @click="categoryDialog(scope.row)"
                  >
                    分类
                  </el-button>
                  <el-button
                    v-if="scope.row.auditStatus === 1"
                    size="mini"
                    type="primary"
                    @click="auditDialog(scope.row)"
                  >
                    审核
                  </el-button>
                  <!-- <el-button
                 
                    size="mini"
                    type="danger"
                    @click="deleteMerchant(scope.row)"
                  >
                    删除
                  </el-button> -->
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </div>

    <!-- 图片预览 -->
    <el-image-viewer
      v-if="imgViewerVisible"
      :on-close="closeImageViewer"
      :url-list="currentImgRow.imageUrl ? currentImgRow.imageUrl.split(',') : []"
      :initial-index="0"
      :z-index="3000"
    />

    <!-- 统一的商户详情/审核对话框 -->
    <el-dialog
      :title="dialogMode === 'detail' ? '商户详情' : '商户审核'"
      :visible.sync="showDetailDialog"
      width="80%"
      :max-height="'80vh'"
      @close="closeDetailDialog"
      custom-class="merchant-dialog"
    >
      <div class="detail-content">
        <!-- 商户信息展示 -->
        <div class="merchant-info-section">
          <h4>商户信息</h4>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="info-item">
                <span>{{ currentRow.merchantName }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <span>{{ currentRow.categoryName }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="info-item">
                <span>{{ currentRow.phone }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <span>{{ currentRow.userName }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="info-item">
                <span>{{ currentRow.address }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="info-item">
                <span>{{ currentRow.description }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="info-item">
                <span>{{ currentRow.crtTime }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <span>{{ currentRow.updTime }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="info-item">
                <span>{{ currentRow.businessHours }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <span
                  >{{ currentRow.pointLng }}, {{ currentRow.pointLat }}</span
                >
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="currentRow.license">
            <el-col :span="24">
              <div class="info-item">
                <div class="license-image">

                  <img
                    v-for="(img, index) in currentRow.license.split(',')"
                    :key="index"
                    :src="img"
                    alt="商户图片"
                    @click="previewImage(currentRow.license)"
                  />
              
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="currentRow.signature||currentRow.agreement">
            <el-col :span="24">
              <div class="info-item">
                <div class="signature-image">
                  <img
                    v-if="currentRow.signature"
                    :src="currentRow.signature"
                    alt="电子签名"
                    @click="previewSignature(currentRow.signature)"
                  />
                  <img
                    v-if="currentRow.agreement"
                    :src="currentRow.agreement"
                    alt="协议签名"
                    @click="previewSignature(currentRow.agreement)"
                  />
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="currentRow.identityFront || currentRow.identityReverse">
            <el-col :span="24">
              <div class="info-item">
                <div class="identity-images">
                  <div class="identity-image-item" v-if="currentRow.identityFront">
                    <div class="image-label">身份证正面</div>
                    <img
                      :src="currentRow.identityFront"
                      alt="身份证正面"
                      @click="previewIdentity(currentRow.identityFront)"
                    />
                  </div>
                  <div class="identity-image-item" v-if="currentRow.identityReverse">
                    <div class="image-label">身份证反面</div>
                    <img
                      :src="currentRow.identityReverse"
                      alt="身份证反面"
                      @click="previewIdentity(currentRow.identityReverse)"
                    />
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="info-item">
                <el-tag
                  :type="getStatusType(currentRow.auditStatus)"
                  size="small"
                >
                  {{ getStatusText(currentRow.auditStatus) }}
                </el-tag>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="currentRow.imageUrl">
            <el-col :span="24">
              <div class="info-item">
                <div class="merchant-image">

                  <img
                    v-for="(img, index) in currentRow.imageUrl.split(',')"
                    :key="index"
                    :src="img"
                    alt="商户图片"
                    @click="previewImage(currentRow.imageUrl)"
                  />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 审核表单 - 仅在审核模式下显示 -->
        <div class="audit-form-section" v-if="dialogMode === 'audit'">
          <h4>审核信息</h4>
          <el-form :model="auditForm" ref="auditForm" label-width="100px">
            <el-form-item label="审核备注" prop="auditRemark">
              <el-input
                v-model="auditForm.auditRemark"
                type="textarea"
                :rows="4"
                placeholder="请输入审核备注"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>

        <!-- 审核历史信息 - 仅在详情模式下显示 -->
        <div
          class="detail-section"
          v-if="dialogMode === 'detail' && currentRow.auditRemark"
        >
          <h4>审核信息</h4>
          <div class="detail-item">
            <span>{{ currentRow.auditRemark }}</span>
          </div>
          <div class="detail-item" v-if="currentRow.auditTime">
            <span>{{ currentRow.auditTime }}</span>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDetailDialog">关 闭</el-button>
        <!-- 审核模式下的按钮 -->
        <template v-if="dialogMode === 'audit'">
          <el-button type="danger" @click="rejectAudit">审核不通过</el-button>
          <el-button type="primary" @click="submitAudit">审核通过</el-button>
        </template>
      </div>
    </el-dialog>

    <!-- 分类对话框 -->
    <el-dialog
      title="商户分类"
      :visible.sync="showCategoryDialog"
      width="400px"
      @close="closeCategoryDialog"
    >
      <el-form :model="categoryForm" ref="categoryForm">
        <el-form-item label="商户名称" style="display: flex;align-items: center;justify-content: flex-start;">
          <span >{{ currentRow.merchantName }}</span>
        </el-form-item>
        <el-form-item label="商户分类" prop="categoryId"> 
          <el-select
            v-model="categoryForm.categoryId"
            placeholder="请选择商户分类"
          >
            <el-option
              v-for="item in merchantCategories"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeCategoryDialog">取 消</el-button>
        <el-button type="primary" @click="submitCategory">确 定</el-button>
      </div>
    </el-dialog>

    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Page from "@/page/commons/page";
import elImageViewer from "element-ui/packages/image/src/image-viewer";
import {
  shopMerchantList,
  shopMerchantAudit,
  shopMerchantAuditNew,
  merchantAdd,
  merchantUpdate,
  merchantDelete,
  merchantCategories,
  uploadImage,
  shopMerchantCount,
  shopMerchantCategoryAll,
  shopMerchantCategory,
  shopMerchantShelf,
  shopMerchantSort
} from "@/api/url";

export default {
  name: "merchant-management",
  components: {
    Page,
    elImageViewer,
  },
  data() {
    return {
      loading: false,
      moduleName: "merchant",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      tableListData: [],
      total: 0,
      showList: true,
      search: {
        limit: 10,
        page: 1,
        merchantName: "",
        categoryId: "",
        auditStatus: null, // 当前审核状态0，审核通过；1，待审核，审核中；2，审核不通过
        // beginTime: "",
        // endTime: "",
      },
      activeTab: "all", // 当前激活的标签页
      currentRow: {},
      showAddDialog: false,
      dialogTitle: "添加商户",
      isEdit: false,
      merchantForm: {
        id: null,
        merchantName: "",
        address: "",
        phone: "",
        contactPerson: "",
        businessHours: "",
        longitude: "",
        latitude: "",
        categoryId: "",
        image: "",
      },
      merchantRules: {
        merchantName: [
          { required: true, message: "请输入商户名称", trigger: "blur" },
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        phone: [{ required: true, message: "请输入电话", trigger: "blur" }],
        contactPerson: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        businessHours: [
          { required: true, message: "请输入营业时间", trigger: "blur" },
        ],
        longitude: [{ required: true, message: "请输入经度", trigger: "blur" }],
        latitude: [{ required: true, message: "请输入纬度", trigger: "blur" }],
        categoryId: [
          { required: true, message: "请选择商户分类", trigger: "change" },
        ],
      },
      merchantCategories: [],
      currentImgRow: {},
      imgViewerVisible: false,
      uploadUrl: uploadImage(),
      showCategoryDialog: false,
      showDetailDialog: false,
      dialogMode: "detail", // 'detail' 或 'audit'
      auditForm: {
        id: null,
        status: 1,
        auditRemark: "",
      },
      categoryForm: {
        id: null,
        categoryId: "",
      },
      statistics: {
        total: 0,
        pending: 0,
        rejected: 0,
        approved: 0,
      },
    };
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      nodeData: (state) => state.nodeData,
      nod: (state) => state.nod,
    }),
  },
  mounted() {
    this.getMerchantCategories();
    this.tableList(1);
    // 添加测试数据
    this.addTestData();
    // 初始化标签页状态
    this.updateActiveTab();
  },
  methods: {
    ...mapMutations(["getPage"]),

    // 获取商户分类列表
    getMerchantCategories() {
      this.$get(shopMerchantCategoryAll())
        .then((res) => {
          this.merchantCategories = res || [];
        })
        .catch(() => {
          // 如果接口失败，使用测试数据
          // this.merchantCategories = [
          //   { id: 1, name: "餐饮美食" },
          //   { id: 2, name: "购物零售" },
          //   { id: 3, name: "生活服务" },
          //   { id: 4, name: "娱乐休闲" },
          //   { id: 5, name: "教育培训" },
          //   { id: 6, name: "医疗健康" },
          //   { id: 7, name: "汽车服务" },
          //   { id: 8, name: "其他" },
          // ];
        });
    },

    // 分页数据接收
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList(curPage) {
      this.loading = true;
      const params = {
        limit: this.search.limit,
        page: curPage,
        categoryId: this.search.categoryId,
        merchantName: this.search.merchantName.trim(),
        auditStatus: this.search.auditStatus,
     
      };
      this.$get(shopMerchantList(), params)
        .then((res) => {
          this.tableListData = res.data.rows || [];
          //翻页
          var pageObj = {
            curIndex: res.data.offset,
            rowsCount: res.data.total,
          };
          this.getPage(pageObj);
        })
        .catch((error) => {
          // 如果接口失败，使用测试数据
          // this.loadTestMerchantData();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 搜索
    searchList() {
      this.search.page = 1;
      this.tableList(1);
    },

    // 删除商户
    deleteMerchant(row) {
      this.$confirm("确定要删除该商户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$delete(merchantDelete(), { id: row.id })
          .then((res) => {
            this.$message.success("删除成功");
            this.tableList(this.search.pageNumber);
          })
          .catch(() => {
            // 如果接口失败，在测试数据中删除
            this.deleteFromTestData(row.id);
          });
      });
    },

    // 从测试数据中删除商户
    deleteFromTestData(merchantId) {
      // 从当前显示的数据中移除
      const index = this.tableListData.findIndex(
        (item) => item.id === merchantId
      );
      if (index > -1) {
        this.tableListData.splice(index, 1);
        this.total = this.total - 1;
        this.$message.success("删除成功");
      }
    },

    // 图片预览
    onImgPreviewClick(row) {
      console.log("onImgPreviewClick - row:", row);
      console.log("onImgPreviewClick - imageUrl:", row.imageUrl);
      if (!row.imageUrl) {
        this.$message.warning("图片地址不存在");
        return;
      }
      this.currentImgRow = row;
      console.log("currentImgRow after set:", this.currentImgRow);
      this.imgViewerVisible = true;
    },

    // 关闭图片预览
    closeImageViewer() {
      this.imgViewerVisible = false;
    },

    // 图片上传成功
    handleImageSuccess(res) {
      this.merchantForm.image = res.data.url;
    },

    // 图片上传前验证
    beforeImageUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    // 获取状态类型
    getStatusType(status) {
      switch (status) {
        case 1:
          return "info"; // 认证中
        case 0:
          return "success"; // 已认证
        case 2:
          return "danger"; // 认证不通过
        default:
          return "info";
      }
    },

    // 获取状态文本
    getStatusText(status) {
      switch (status) {
        case 1:
          return "认证中";
        case 0:
          return "已认证";
        case 2:
          return "认证不通过";
        default:
          return "未知";
      }
    },

    // 审核对话框
    auditDialog(row) {
      this.currentRow = row;
      this.dialogMode = "audit";
      this.auditForm = {
        id: row.id,
        status: 1,
        auditRemark: "",
      };
      this.showDetailDialog = true;
    },

    // 分类对话框
    categoryDialog(row) {
      this.currentRow = row;
      this.categoryForm = {
        id: row.id,
        categoryId: row.categoryId,
      };
      this.showCategoryDialog = true;
    },

    // 提交审核（通过）
    async submitAudit() {
      if (!this.auditForm.auditRemark.trim()) {
        this.$message.warning("请输入审核备注");
        return;
      }
      const params = {
        merchantId: this.auditForm.id,
        auditStatus: 0, // 审核通过
        auditInfo: this.auditForm.auditRemark,
      };
      try {
        const res = await this.$get(
          `${shopMerchantAuditNew()}`,
          params
        );
        if (res.status === 200) {
          this.$message.success("审核通过");
          // 关闭对话框并重置表单
          this.showDetailDialog = false;
          this.auditForm = {
            id: null,
            status: 1,
            auditRemark: "",
          };
          // 刷新列表和统计数据
          this.tableList(this.curIndex || 1);
          this.getStatistics();
          return;
        }
        throw new Error(res.message || "审核通过请求失败");
      } catch (error) {
        console.error("审核通过请求失败:", error);
      }
    },

    // 审核不通过
    async rejectAudit() {
      if (!this.auditForm.auditRemark.trim()) {
        this.$message.warning("请输入审核备注");
        return;
      }
      const params = {
        merchantId: this.auditForm.id,
        auditStatus: 2, // 审核不通过
        auditInfo: this.auditForm.auditRemark,
      };
      try {
        const res = await this.$get(
          `${shopMerchantAuditNew()}`,
          params
        );
        if (res.status === 200) {
          this.$message.success("审核不通过");
          // 关闭对话框并重置表单
          this.showDetailDialog = false;
          this.auditForm = {
            id: null,
            status: 1,
            auditRemark: "",
          };
          // 刷新列表和统计数据
          this.tableList(this.curIndex || 1);
          this.getStatistics();
          return;
        }
        throw new Error(res.message || "审核不通过请求失败");
      } catch (error) {
        console.error("审核不通过请求失败:", error);
      }
    },

    // 预览图片
    previewImage(imageUrl) {
      console.log("previewImage - imageUrl:", imageUrl);
      if (!imageUrl) {
        this.$message.warning("图片地址不存在");
        return;
      }
      this.currentImgRow = { imageUrl: imageUrl };
      console.log("currentImgRow after set:", this.currentImgRow);
      this.imgViewerVisible = true;
    },

    // 预览营业执照
    previewLicense(licenseUrl) {
      console.log("previewLicense - licenseUrl:", licenseUrl);
      if (!licenseUrl) {
        this.$message.warning("营业执照图片地址不存在");
        return;
      }
      this.currentImgRow = { imageUrl: licenseUrl };
      this.imgViewerVisible = true;
    },

    // 预览电子签名
    previewSignature(signatureUrl) {
      console.log("previewSignature - signatureUrl:", signatureUrl);
      if (!signatureUrl) {
        this.$message.warning("电子签名图片地址不存在");
        return;
      }
      this.currentImgRow = { imageUrl: signatureUrl };
      this.imgViewerVisible = true;
    },

    // 预览身份证图片
    previewIdentity(identityUrl) {
      console.log("previewIdentity - identityUrl:", identityUrl);
      if (!identityUrl) {
        this.$message.warning("身份证图片地址不存在");
        return;
      }
      this.currentImgRow = { imageUrl: identityUrl };
      this.imgViewerVisible = true;
    },

    // 处理上下架状态变化
    async handleShelfChange(row) {
      try {
        console.log("上下架状态变化:", row.published, typeof row.published);
        const params = {
          id: row.id,
          published: row.published, // 1 上架，2 下架
        };
        // 调用实际的API接口
        const res = await this.$putRequest(`${shopMerchantAudit()}/${row.id}`, params);
        
        if (res.status === 200) {
          this.$message.success(`商户${row.published === 1 ? '上架' : '下架'}成功`);
          // 刷新列表
          this.tableList(this.curIndex || 1);
        } else {
          throw new Error(res.message || "上下架操作失败");
        }
      } catch (error) {
        console.error("上下架操作失败:", error);
        // 恢复原状态
        row.published = row.published === 1 ? 2 : 1;
      }
    },

    // 处理排序变化
    async handleSortChange(row) {
      try {
        const params = {
          id: row.id,
          sort: row.sort
        };
        
        // 调用实际的API接口
        const res = await this.$putRequest(`${shopMerchantAudit()}/${row.id}`, params);
        
        if (res.status === 200) {
          this.$message.success("排序更新成功");
          // 刷新列表
          this.tableList(this.curIndex || 1);
        } else {
          throw new Error(res.message || "排序更新失败");
        }
      } catch (error) {
        console.error("排序更新失败:", error);
        this.$message.error(error.message || "排序更新失败，请重试");
      }
    },

    // 开始排序编辑
    startSortEdit(row) {
      console.log("开始编辑排序:", row);
      console.log("编辑前 editingSort:", row.editingSort);
      this.$set(row, 'editingSort', true);
      this.$set(row, 'tempSort', row.sort);
      console.log("编辑后 editingSort:", row.editingSort);
      console.log("tempSort:", row.tempSort);
    },

    // 确认排序编辑
    async confirmSortEdit(row) {
      try {
        if (row.tempSort === row.sort) {
        // 没有变化，直接取消编辑
        this.$set(row, 'editingSort', false);
        return;
        }

        const params = {
          id: row.id,
          sort: row.tempSort
        };
        
        // 调用实际的API接口
        const res = await this.$putRequest(`${shopMerchantAudit()}/${row.id}`, params);
        
        if (res.status === 200) {
          this.$set(row, 'sort', row.tempSort);
          this.$set(row, 'editingSort', false);
          this.$message.success("排序更新成功");
          // 刷新列表
          this.tableList(this.curIndex || 1);
        } else {
          throw new Error(res.message || "排序更新失败");
        }
      } catch (error) {
        console.error("排序更新失败:", error);
        // 恢复原值
        this.$set(row, 'tempSort', row.sort);
        this.$set(row, 'editingSort', false);
      }
    },

    // 取消排序编辑
    cancelSortEdit(row) {
      this.$set(row, 'tempSort', row.sort);
      this.$set(row, 'editingSort', false);
    },

    // 提交分类
    async submitCategory() {
      try {
        if (!this.categoryForm.categoryId) {
          this.$message.warning("请选择商户分类");
          return;
        }
        
        const res = await this.$get(
          `${shopMerchantCategory()}`,
          {
            categoryId: this.categoryForm.categoryId,
            merchantId: this.categoryForm.id,
          }
        );
        if (res.status === 200) {
          this.$message.success("分类更新成功");
          // 关闭对话框并重置表单
          this.showCategoryDialog = false;
          this.categoryForm = {
            id: null,
            categoryId: "",
          };
          // 刷新列表
          this.tableList(this.curIndex || 1);
          return;
        }
        throw new Error(res.message || "分类更新请求失败"); // 抛出错误，以便在调用处捕获并处理
      } catch (error) {
        console.error(error);
      }
    },

    // 关闭分类对话框
    closeCategoryDialog() {
      this.showCategoryDialog = false;
      this.categoryForm = {
        id: null,
        categoryId: "",
      };
    },

    // 查看详情
    viewDetail(row) {
      this.currentRow = row;
      this.dialogMode = "detail";
      this.showDetailDialog = true;
    },

    // 关闭详情对话框
    closeDetailDialog() {
      this.showDetailDialog = false;
      this.currentRow = {};
      this.dialogMode = "detail";
      // 重置审核表单
      this.auditForm = {
        id: null,
        status: 1,
        auditRemark: "",
      };
    },

    // 处理标签页点击
    handleTabClick(tab) {
      console.log("点击标签页:", tab.name);
      const statusMap = {
        all: null,
        pending: 1,
        rejected: 2,
        approved: 0,
        toBeComplete: 3, // 待完善信息
      };
      this.filterByStatus(statusMap[tab.name]);
    },

    // 按状态筛选
    filterByStatus(status) {
      this.search.auditStatus = status;
      this.search.page = 1;
      this.updateActiveTab();
      this.tableList(1);
    },

    // 更新激活的标签页
    updateActiveTab() {
      const tabMap = {
        null: "all",
        1: "pending",
        2: "rejected",
        0: "approved",
      };
      this.activeTab = tabMap[this.search.auditStatus] || "all";
      console.log("当前activeTab:", this.activeTab, "auditStatus:", this.search.auditStatus);
    },

    // 获取统计数据
    async getStatistics() {
      try {
        const res = await this.$get(shopMerchantCount());
        if (res && res.status === 200) {
          const { fail, pass, pend, to_be_complete, total } = res?.data?.[0];
          this.statistics = {
            total: total || 0,
            pending: pend || 0,
            rejected: fail || 0,
            approved: pass || 0,
            toBeComplete: to_be_complete || 0,
          };
        } else {
          // 如果接口返回失败
          this.statistics = {
            total: 0,
            pending: 0,
            rejected: 0,
            approved: 0,
            toBeComplete: 0,
          };
        }
      } catch (error) {
        // 如果接口调用失败
        this.statistics = {
          total: 0,
          pending: 0,
          rejected: 0,
          approved: 0,
          toBeComplete: 0,
        };
      }
    },

    // 获取所有测试数据（用于统计）
    getAllTestData() {
      return [
        {
          id: 1,
          merchantName: "星巴克咖啡",
          address: "北京市朝阳区三里屯太古里南区S8-1F",
          phone: "010-6416-1234",
          contactPerson: "张经理",
          businessHours: "07:00-22:00",
          longitude: "116.447",
          latitude: "39.937",
          categoryId: 1,
          categoryName: "餐饮美食",
          status: 0,
          auditStatus: 0, // 已认证
          published: 1, // 上架状态
          sort: 1, // 排序
          editingSort: false, // 编辑状态
          imageUrl:
            "https://via.placeholder.com/200x150/4A90E2/FFFFFF?text=星巴克",
          license: "https://via.placeholder.com/400x300/4A90E2/FFFFFF?text=营业执照",
          signature: "https://via.placeholder.com/400x200/FF6B6B/FFFFFF?text=电子签名",
          agreement: "https://via.placeholder.com/400x200/9B59B6/FFFFFF?text=协议签名",
          identityFront: "https://via.placeholder.com/360x240/4A90E2/FFFFFF?text=身份证正面",
          identityReverse: "https://via.placeholder.com/360x240/4A90E2/FFFFFF?text=身份证反面",
          createTime: "2024-01-15 10:30:00",
          description:
            "全球知名咖啡连锁品牌，提供高品质咖啡和轻食，环境优雅舒适，是商务洽谈和休闲聚会的理想场所。",
        },
        {
          id: 2,
          merchantName: "海底捞火锅",
          address: "上海市浦东新区陆家嘴环路1000号恒生银行大厦B1层",
          phone: "021-5888-8888",
          contactPerson: "李店长",
          businessHours: "11:00-02:00",
          longitude: "121.499",
          latitude: "31.239",
          categoryId: 1,
          categoryName: "餐饮美食",
          status: 1,
          auditStatus: 1, // 待认证
          imageUrl:
            "https://via.placeholder.com/200x150/E74C3C/FFFFFF?text=海底捞",
          license: "https://via.placeholder.com/400x300/E74C3C/FFFFFF?text=营业执照",
          signature: "https://via.placeholder.com/400x200/FF6B6B/FFFFFF?text=电子签名",
          agreement: "https://via.placeholder.com/400x200/E74C3C/FFFFFF?text=协议签名",
          identityFront: "https://via.placeholder.com/360x240/E74C3C/FFFFFF?text=身份证正面",
          identityReverse: "https://via.placeholder.com/360x240/E74C3C/FFFFFF?text=身份证反面",
          createTime: "2024-01-20 14:20:00",
          description:
            "知名火锅连锁品牌，以优质服务和新鲜食材著称，提供24小时营业服务，是朋友聚餐和家庭聚会的首选。",
        },
        {
          id: 3,
          merchantName: "优衣库",
          address: "广州市天河区天河路208号天河城购物中心2楼",
          phone: "020-3882-8888",
          contactPerson: "王主管",
          businessHours: "10:00-22:00",
          longitude: "113.324",
          latitude: "23.132",
          categoryId: 2,
          categoryName: "购物零售",
          status: 2,
          auditStatus: 2, // 认证不通过
          imageUrl:
            "https://via.placeholder.com/200x150/27AE60/FFFFFF?text=优衣库",
          license: "https://via.placeholder.com/400x300/27AE60/FFFFFF?text=营业执照",
          signature: "https://via.placeholder.com/400x200/FF6B6B/FFFFFF?text=电子签名",
          createTime: "2024-02-01 09:15:00",
          description:
            "日本快时尚品牌，以简约设计和优质面料闻名，提供男女装、童装等全系列服装，价格亲民，品质可靠。",
        },
        {
          id: 4,
          merchantName: "万达影城",
          address: "深圳市南山区深南大道9668号大冲商务中心A座3楼",
          phone: "0755-8888-9999",
          contactPerson: "陈经理",
          businessHours: "09:00-24:00",
          longitude: "113.961",
          latitude: "22.543",
          categoryId: 4,
          categoryName: "娱乐休闲",
          status: 2,
          auditStatus: 2, // 认证不通过
          imageUrl:
            "https://via.placeholder.com/200x150/9B59B6/FFFFFF?text=万达影城",
          license: "https://via.placeholder.com/400x300/9B59B6/FFFFFF?text=营业执照",
          signature: "https://via.placeholder.com/400x200/FF6B6B/FFFFFF?text=电子签名",
          createTime: "2024-02-10 16:45:00",
          description:
            "现代化多厅影院，配备IMAX、杜比全景声等先进设备，提供舒适的观影环境和丰富的影片选择。",
        },
        {
          id: 5,
          merchantName: "新东方教育",
          address: "杭州市西湖区文三路259号昌地火炬大厦A座15楼",
          phone: "0571-8888-7777",
          contactPerson: "刘老师",
          businessHours: "08:30-21:00",
          longitude: "120.155",
          latitude: "30.274",
          categoryId: 5,
          categoryName: "教育培训",
          status: 1,
          auditStatus: 1, // 待认证
          imageUrl:
            "https://via.placeholder.com/200x150/F39C12/FFFFFF?text=新东方",
          license: "https://via.placeholder.com/400x300/F39C12/FFFFFF?text=营业执照",
          signature: "https://via.placeholder.com/400x200/FF6B6B/FFFFFF?text=电子签名",
          createTime: "2024-02-15 11:30:00",
          description:
            "知名教育培训机构，提供英语、数学、语文等全科辅导，拥有专业师资团队和完善的教学体系。",
        },
        {
          id: 6,
          merchantName: "美年大健康",
          address: "成都市锦江区红星路三段1号IFS国际金融中心2号楼15层",
          phone: "028-8888-6666",
          contactPerson: "赵医生",
          businessHours: "08:00-18:00",
          longitude: "104.066",
          latitude: "30.659",
          categoryId: 6,
          categoryName: "医疗健康",
          status: 2,
          imageUrl:
            "https://via.placeholder.com/200x150/1ABC9C/FFFFFF?text=美年大健康",
          license: "https://via.placeholder.com/400x300/1ABC9C/FFFFFF?text=营业执照",
          signature: "https://via.placeholder.com/400x200/FF6B6B/FFFFFF?text=电子签名",
          createTime: "2024-02-20 13:20:00",
          description:
            "专业体检机构，提供全面的健康体检服务，配备先进医疗设备，为个人和企业提供定制化健康管理方案。",
        },
        {
          id: 7,
          merchantName: "途虎养车",
          address: "武汉市江汉区中山大道818号佳丽广场B1层",
          phone: "027-8888-5555",
          contactPerson: "孙技师",
          businessHours: "08:00-20:00",
          longitude: "114.305",
          latitude: "30.593",
          categoryId: 7,
          categoryName: "汽车服务",
          status: 0,
          auditStatus: 0, // 已认证
          published: 2, // 下架状态
          sort: 2, // 排序
          editingSort: false, // 编辑状态
          imageUrl:
            "https://via.placeholder.com/200x150/34495E/FFFFFF?text=途虎养车",
          license: "https://via.placeholder.com/400x300/34495E/FFFFFF?text=营业执照",
          signature: "https://via.placeholder.com/400x200/FF6B6B/FFFFFF?text=电子签名",
          createTime: "2024-02-25 15:10:00",
          description:
            "专业汽车养护平台，提供轮胎、机油、保养等汽车服务，价格透明，质量保证，让车主享受便捷的养车体验。",
        },
        {
          id: 8,
          merchantName: "顺丰速运",
          address: "南京市鼓楼区中山路321号现代大厦A座8楼",
          phone: "025-8888-4444",
          contactPerson: "周专员",
          businessHours: "08:00-19:00",
          longitude: "118.767",
          latitude: "32.041",
          categoryId: 3,
          categoryName: "生活服务",
          status: 2,
          auditStatus: 0, // 已认证
          published: 1, // 上架状态
          sort: 3, // 排序
          editingSort: false, // 编辑状态
          imageUrl:
            "https://via.placeholder.com/200x150/3498DB/FFFFFF?text=顺丰速运",
          createTime: "2024-03-01 10:00:00",
          description:
            "国内领先的快递物流企业，提供快速、安全、可靠的快递服务，支持同城、国内、国际等多种配送方式。",
        },
        {
          id: 9,
          merchantName: "肯德基",
          address: "西安市雁塔区小寨西路126号百盛购物中心1楼",
          phone: "029-8888-3333",
          contactPerson: "吴店长",
          businessHours: "06:00-24:00",
          longitude: "108.948",
          latitude: "34.258",
          categoryId: 1,
          categoryName: "餐饮美食",
          status: 1,
          imageUrl:
            "https://via.placeholder.com/200x150/E67E22/FFFFFF?text=肯德基",
          createTime: "2024-03-05 12:15:00",
          description:
            "全球知名快餐连锁品牌，以炸鸡、汉堡等西式快餐为主，24小时营业，为顾客提供便捷美味的用餐体验。",
        },
        {
          id: 10,
          merchantName: "华为体验店",
          address: "重庆市渝中区解放碑步行街88号大都会东方广场1楼",
          phone: "023-8888-2222",
          contactPerson: "郑顾问",
          businessHours: "10:00-22:00",
          longitude: "106.551",
          latitude: "29.563",
          categoryId: 2,
          categoryName: "购物零售",
          status: 2,
          imageUrl:
            "https://via.placeholder.com/200x150/2ECC71/FFFFFF?text=华为体验店",
          createTime: "2024-03-10 14:30:00",
          description:
            "华为官方体验店，展示华为最新手机、平板、笔记本等产品，提供专业的产品咨询和售后服务。",
        },
        {
          id: 11,
          merchantName: "麦当劳",
          address: "天津市和平区南京路108号伊势丹百货1楼",
          phone: "022-8888-1111",
          contactPerson: "钱经理",
          businessHours: "06:00-24:00",
          longitude: "117.200",
          latitude: "39.118",
          categoryId: 1,
          categoryName: "餐饮美食",
          status: 3,
          imageUrl:
            "https://via.placeholder.com/200x150/FF6B6B/FFFFFF?text=麦当劳",
          createTime: "2024-03-15 09:30:00",
          description:
            "全球知名快餐连锁品牌，以汉堡、薯条等经典美食著称，24小时营业，为顾客提供快速便捷的用餐服务。",
        },
        {
          id: 12,
          merchantName: "无印良品",
          address: "青岛市市南区香港中路8号青岛银行大厦1楼",
          phone: "0532-8888-0000",
          contactPerson: "孙店长",
          businessHours: "10:00-22:00",
          longitude: "120.382",
          latitude: "36.067",
          categoryId: 2,
          categoryName: "购物零售",
          status: 3,
          imageUrl:
            "https://via.placeholder.com/200x150/4ECDC4/FFFFFF?text=无印良品",
          createTime: "2024-03-20 16:45:00",
          description:
            "日本生活方式品牌，以简约、自然、环保为理念，提供服装、家居、文具等生活用品，追求品质与美感的平衡。",
        },
      ];
    },

    // 添加测试数据
    addTestData() {
      // 确保有商户分类数据
      if (this.merchantCategories.length === 0) {
        this.merchantCategories = [
          { id: 1, name: "餐饮美食" },
          { id: 2, name: "购物零售" },
          { id: 3, name: "生活服务" },
          { id: 4, name: "娱乐休闲" },
          { id: 5, name: "教育培训" },
          { id: 6, name: "医疗健康" },
          { id: 7, name: "汽车服务" },
          { id: 8, name: "其他" },
        ];
      }

      // 加载测试商户数据
      this.loadTestMerchantData();
    },

    // 加载测试商户数据
    loadTestMerchantData() {
      const testData = this.getAllTestData();

      // 根据搜索条件过滤数据
      let filteredData = testData;

      if (this.search.merchantName) {
        filteredData = filteredData.filter((item) =>
          item.merchantName.includes(this.search.merchantName)
        );
      }

      if (this.search.merchantCategory) {
        filteredData = filteredData.filter(
          (item) => item.categoryId === this.search.merchantCategory
        );
      }

      if (this.search.phone) {
        filteredData = filteredData.filter(
          (item) =>
            item.phone.includes(this.search.phone) ||
            item.contactPerson.includes(this.search.phone)
        );
      }

      // 根据状态筛选
      if (this.search.status !== null) {
        filteredData = filteredData.filter(
          (item) => item.status === this.search.status
        );
      }

      // 分页处理
      const pageSize = this.search.pageSize;
      const pageNumber = this.search.pageNumber;
      const startIndex = (pageNumber - 1) * pageSize;
      const endIndex = startIndex + pageSize;

      this.tableListData = filteredData.slice(startIndex, endIndex);
      this.total = filteredData.length;

      // 计算统计数据
      this.getStatistics();
    },
  },
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/* 状态标签页样式 */
.status-tabs {
  margin-bottom: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.status-tabs .el-tabs__header {
  margin: 0;
  border-bottom: 1px solid #e6e6e6;
}

.status-tabs .el-tabs__nav-wrap {
  padding: 0;
}

.status-tabs .el-tabs__item {
  padding: 0 20px;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  font-weight: 500;
}

.status-tabs .el-tabs__item.is-active {
  color: #409eff;
}

.status-tabs .el-tabs__active-bar {
  background-color: #409eff;
}

.tab-badge {
  margin-left: 8px;
}


.merchant-info-section {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 6px;
}

.audit-form-section {
  padding: 15px;
  background-color: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
}

.merchant-info-section h4,
.audit-form-section h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 2px solid #409eff;
  padding-bottom: 8px;
}

.info-item {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.info-item label {
  font-weight: 500;
  color: #666;
  min-width: 80px;
  margin-right: 8px;
}

.info-item span {
  color: #333;
  flex: 1;
}

.merchant-image {
  margin-top: 8px;
}

.merchant-image img {
  width: 120px;
  height: 90px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ddd;
  transition: all 0.3s;
}

.merchant-image img:hover {
  border-color: #409eff;
  transform: scale(1.05);
}

.license-image img,
.signature-image img {
  width: 200px;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ddd;
  transition: all 0.3s;
  margin-right: 10px;
  margin-bottom: 10px;
}

.license-image img:hover,
.signature-image img:hover {
  border-color: #409eff;
  transform: scale(1.05);
}

.identity-images {
  display: flex;
  gap: 20px;
  margin-top: 8px;
}

.identity-image-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
  font-weight: 500;
}

.identity-image-item img {
  width: 180px;
  height: 120px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ddd;
  transition: all 0.3s;
}

.identity-image-item img:hover {
  border-color: #409eff;
  transform: scale(1.05);
}
.table {
  height: calc(100vh - 250px) !important;
}
/* 强制移除所有可能的边框 */
.status-tabs .el-tabs {
  border: none !important;
}

.status-tabs .el-tabs__header {
  border: none !important;
  border-bottom: none !important;
}

.status-tabs .el-tabs__nav {
  border: none !important;
}

.status-tabs .el-tabs__nav-wrap {
  border: none !important;
  border-bottom: none !important;
}

.status-tabs .el-tabs__nav-scroll {
  border: none !important;
}
/* 移除所有伪元素的边框 */
.status-tabs *::before,
.status-tabs *::after {
  border: none !important;
  border-bottom: none !important;
}

/* 使用深度选择器强制覆盖 */
.status-tabs >>> .el-tabs__header {
  border-bottom: none !important;
}

.status-tabs >>> .el-tabs__nav-wrap::after {
  display: none !important;
}

.status-tabs >>> .el-tabs__nav-wrap {
  border-bottom: none !important;
}

/* 如果还是不行，尝试更具体的选择器 */
.status-tabs .el-tabs__header .el-tabs__nav-wrap::after {
  display: none !important;
  content: none !important;
  border: none !important;
}

/* 详情对话框样式 */
.detail-content {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 10px;
}

/* 自定义滚动条样式 */
.detail-content::-webkit-scrollbar {
  width: 6px;
}

.detail-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.detail-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.detail-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 完全控制商户对话框的滚动行为 */
.merchant-dialog .el-dialog {
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  margin-top: 5vh !important;
  margin-bottom: 5vh !important;
}

.merchant-dialog .el-dialog__header {
  flex-shrink: 0;
  padding: 20px 20px 10px;
  border-bottom: 1px solid #e6e6e6;
}

.merchant-dialog .el-dialog__body {
  flex: 1;
  overflow: hidden;
  padding: 20px;
  max-height: calc(85vh - 140px);
}

.merchant-dialog .el-dialog__footer {
  flex-shrink: 0;
  padding: 10px 20px 20px;
  border-top: 1px solid #e6e6e6;
  background-color: #fafafa;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .merchant-dialog .el-dialog {
    width: 95% !important;
    max-height: 90vh;
    margin: 5vh auto !important;
  }
  
  .detail-content {
    max-height: 65vh;
  }
  
  .merchant-dialog .el-dialog__body {
    padding: 15px;
    max-height: calc(90vh - 140px);
  }
}

.detail-section {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 6px;
}

.detail-section h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 2px solid #409eff;
  padding-bottom: 8px;
}

.detail-item {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.detail-item label {
  font-weight: 500;
  color: #666;
  min-width: 80px;
  margin-right: 8px;
}

.detail-item span {
  color: #333;
  flex: 1;
}

.merchant-image-detail {
  margin-top: 8px;
}

.merchant-image-detail img {
  width: 200px;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ddd;
  transition: all 0.3s;
}

.merchant-image-detail img:hover {
  border-color: #409eff;
  transform: scale(1.05);
}

/* 统一使用 info-item 样式 */
.merchant-info-section .info-item {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.merchant-info-section .info-item label {
  font-weight: 500;
  color: #666;
  min-width: 80px;
  margin-right: 8px;
}

.merchant-info-section .info-item span {
  color: #333;
  flex: 1;
}

/* 排序编辑样式 */
.sort-edit-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sort-display {
  display: flex;
  align-items: center;
  gap: 5px;
}

.sort-edit-icon {
  cursor: pointer;
  color: #409eff;
  font-size: 14px;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.sort-edit-icon:hover {
  opacity: 1;
}

.sort-edit-input {
  display: flex;
  align-items: center;
  gap: 5px;
}

.sort-confirm-icon {
  cursor: pointer;
  color: #67c23a;
  font-size: 14px;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.sort-confirm-icon:hover {
  opacity: 1;
}

.sort-cancel-icon {
  cursor: pointer;
  color: #f56c6c;
  font-size: 14px;
  opacity: 0.7;
  transition: opacity 0.3s;
}

.sort-cancel-icon:hover {
  opacity: 1;
}
</style>